export enum OpenBiddingImproverCount {
    top2 = 2,
    top3 = 3,
    top4 = 4,
    top5 = 5
}
